import React, { useEffect } from 'react';
import { Bell, Calendar, Flag, MessageSquare, Users, Wallet } from 'lucide-react';
import { Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { getSpaceDetails } from 'helpers/fakebackend_helper';
import { useQuery } from 'react-query';
import { Card, CardBody, CardTitle, CardText } from "reactstrap";

export default function SpaceMenuNavigationPage() {
  //gt id from url params using react router dom
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      localStorage.setItem('spaceId', id);
    }
  }, [id]);
  
  const { data, isLoading } = useQuery(['space_details', id], () => getSpaceDetails(id), {
    // staleTime: 120000,
    refetchOnWindowFocus: false,
  });
  return (
    <div className="container py-5" style={{marginTop: "100px"}}>
      <h1 className="fs-2 fw-semibold mb-4">{data?.parenting_space?.name}</h1>
      <Card className="shadow-sm mb-4">
      <CardBody>
        <CardTitle tag="h5" className="text-primary">Owner Information</CardTitle>
        <hr />
        <CardText>
          <strong>Name:</strong> {data?.parenting_space?.owner?.name || "N/A"}
        </CardText>
        <CardText>
          <strong>Email:</strong> {data?.parenting_space?.owner?.email || "N/A"}
        </CardText>
      </CardBody>
    </Card>
      <hr />
      <Card style={{padding: "10px"}}>

      <div className="row g-3">
        <h3 className="fs-4 fw-semibold">Space Menu</h3>
        <div className="col-md-6">
          <Link to={`/chat/${id}`} className="text-decoration-none">
            <div className="card p-4 hover-shadow" style={{ color: "black" }}>
              <div className="d-flex align-items-center gap-3">
                <div className="p-2 bg-light rounded">
                  <MessageSquare className="text-primary" size={20} />
                </div>
                <span className="fw-medium">Messages</span>
              </div>
            </div>
          </Link>
        </div>

        <div className="col-md-6">
          <Link to="/reported-messages" className="text-decoration-none">
            <div className="card p-4 hover-shadow" style={{ color: "black" }}>
              <div className="d-flex align-items-center gap-3">
                <div className="p-2 bg-light rounded">
                  <Flag className="text-primary" size={20} />
                </div>
                <span className="fw-medium">Flagged Messages</span>
              </div>
            </div>
          </Link>
        </div>

        <div className="col-md-6">
          <Link to={`/expense/${id}`}
           className="text-decoration-none">
            <div className="card p-4 hover-shadow" style={{ color: "black" }}>
              <div className="d-flex align-items-center gap-3">
                <div className="p-2 bg-light rounded">
                  <Wallet className="text-primary" size={20} />
                </div>
                <span className="fw-medium">Expenses</span>
              </div>
            </div>
          </Link>
        </div>

        <div className="col-md-6">
          <Link to={`/notifications/${id}`}
           className="text-decoration-none">
            <div className="card p-4 hover-shadow" style={{ color: "black" }}>
              <div className="d-flex align-items-center gap-3">
                <div className="p-2 bg-light rounded">
                  <Bell className="text-primary" size={20} />
                </div>
                <span className="fw-medium">Notifications</span>
              </div>
            </div>
          </Link>
        </div>

        <div className="col-md-6">
          <Link to="/calendar/:id" className="text-decoration-none">
            <div className="card p-4 hover-shadow" style={{ color: "black" }}>
              <div className="d-flex align-items-center gap-3">
                <div className="p-2 bg-light rounded">
                  <Calendar className="text-primary" size={20} />
                </div>
                <span className="fw-medium">Activity Schedule</span>
              </div>
            </div>
          </Link>
        </div>

        <div className="col-md-6">
          <Link to={`/members/${id}`} 
          className="text-decoration-none">
            <div className="card p-4 hover-shadow" style={{ color: "black" }}>
              <div className="d-flex align-items-center gap-3">
                <div className="p-2 bg-light rounded">
                  <Users className="text-primary" size={20} />
                </div>
                <span className="fw-medium">Members</span>
              </div>
            </div>
          </Link>
        </div>
      </div>
      </Card>

    </div>
  );
}
